import React from 'react';
import { Link } from 'react-router-dom';

/**
 * PageShell — the KR Enterprise standard page container.
 *
 * Provides:
 *   • Light "workspace" canvas (navy · gold · white)
 *   • Uppercase breadcrumb strip
 *   • Big navy page title + optional description
 *   • Right-aligned action slot for primary buttons
 *
 * Usage:
 *   <PageShell
 *     title="Workflow Settings"
 *     description="Operational tuning for KR workflows."
 *     breadcrumbs={[{ label: 'Dashboard', href: '/dashboard' }, { label: 'Workflow Settings' }]}
 *     actions={<button className="kr-btn-primary">…</button>}
 *   >
 *     …page content…
 *   </PageShell>
 */
export const PageShell = ({ title, description, breadcrumbs = [], actions, children, testId }) => {
  return (
    <div className="kr-page" data-testid={testId}>
      <header className="kr-page-header">
        <div className="min-w-0">
          {breadcrumbs.length > 0 && (
            <nav className="kr-crumb" aria-label="Breadcrumb">
              {breadcrumbs.map((c, i) => (
                <span key={i}>
                  {c.href && i < breadcrumbs.length - 1 ? (
                    <Link to={c.href}>{c.label}</Link>
                  ) : (
                    <span style={{ color: 'var(--kr-navy-700)' }}>{c.label}</span>
                  )}
                  {i < breadcrumbs.length - 1 && <span className="sep">/</span>}
                </span>
              ))}
            </nav>
          )}
          <h1 className="kr-page-title">{title}</h1>
          {description && <p className="kr-page-description">{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-3 flex-shrink-0">{actions}</div>}
      </header>
      {children}
    </div>
  );
};

export default PageShell;
